import { Component, OnInit,ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
declare let $: any;
declare let Ladda:any
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute,Params} from '@angular/router';
import { Helper } from '../_helpers/index';

@Component({
  selector: 'app-wifidetails',
  templateUrl: './wifidetails.component.html',
  styleUrls: ['./wifidetails.component.css'],
})

export class WifidetailsComponent{
data:any;
  backendUrl:any;
  sel_id:any;
  loadingnew = false;
  loading = false;
  complexForm:FormGroup;
  model: any = {};
  id:number;
  wifiId:number;
  branchID:any;
  time_zone:any;

constructor(fb: FormBuilder,private http: Http,private datePipe: DatePipe,private userService:UserService,private router: Router,private activatedRoute: ActivatedRoute,private helper: Helper) {
    this.complexForm = fb.group({
      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.

      // We can use more than one validator per field. If we want to use more than one validator we have to wrap our array of validators with a Validators.compose function. Here we are using a required, minimum length and maximum length validator.

    })

  }
  ngOnInit(){
  let url=window.location.hostname;
    // if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    // else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    // else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}
    // else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
     let restaurant_id=currentUser.restaurant_id;
     this.time_zone = currentUser.time_zone ? currentUser.time_zone : 'America/Mexico_City';

     var sql1="SELECT * FROM fb_branches  where restaurant_id="+restaurant_id;
        this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql1}))
          .subscribe(data => {
          if(data.length > 0) {
            this.branchID = data[0].branch_id;
     let sql="SELECT * FROM fb_restaurant_wifi where branch_id="+this.branchID; 
     let headers = new Headers ({  'Content-Type': 'application/json' });
     let options = new RequestOptions({ headers: headers, method: "post" });

      this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql}))
            .subscribe(data1 => {
            if(data1.length > 0) {
              this.model.network_name = data1[0].wifi_user;
              this.model.password = data1[0].wifi_password;
              this.wifiId = data1[0].branch_id;
            }           
        });
        }
        });
$(document).ready(function(){

$.validator.addMethod("clsRequired", function(value, element) { 
  return value == '' || value.trim().length != 0; 
}, "This Field is required");

  $("input").on("keypress", function(e) {
    if (e.which === 32 && !this.value.length)
        e.preventDefault();
});
	
	$('#network_detail').validate({
        rules:{
          network_name:{required:true},
          password:{required:true},

        },
        messages:{
          network_name:{required:"This field is required"},
          password:{required:"This field is required"},

        },
        errorPlacement: function(error, element) {
          if (element.type == 'checkbox') {
            error.appendTo(element.parent());
          }
          else {
            error.insertAfter(element);
          }
        }

      })
            })
  }

  save_network()
  {
    let dayData = '';
    let date=new Date();
    let date_time=moment(date).format("YYYY-MM-DD HH:mm:ss");
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let restaurant_id=currentUser.restaurant_id;
    if($('#network_detail').valid())
    {
      var l = Ladda.create( document.querySelector( '#save_network') );
      l.start();
      if(this.wifiId){
        let userdata = {
        wifi_user : this.model.network_name,
        wifi_password : this.model.password,
        branch_id : this.branchID
      };
        let sql="update fb_restaurant_wifi set ? where branch_id="+this.branchID;
        this.userService.insert(this.backendUrl,JSON.stringify({'query': sql,'data':userdata}))
          .subscribe(data => {
            l.stop();
            this.ngOnInit();
            $('#success').html('Wi-Fi details updated successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
      }
      else{
      if(this.branchID == '' || this.branchID == undefined) {
        alert('Please fill contacts details first.');
        l.stop();
        return false;
      }else {
      let userdata = {
        wifi_user : this.model.network_name,
        wifi_password : this.model.password,
        branch_id : this.branchID,
        created_at : this.helper.getDateTimeInClientTz(date_time,this.time_zone)
      };
        let sql="insert into fb_restaurant_wifi SET ?"
        this.userService.insert(this.backendUrl,({'query': sql,'data':userdata}))
          .subscribe(data => {
            this.wifiId = data.id;
            l.stop();
            this.ngOnInit();
            $('#success').html('Wi-Fi details saved successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
          }
      }

    }
  }
}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/wifidetails/wifidetails.component.ts